module.exports = __webpack_public_path__ + "static/media/icon-bed.72a7823b.svg";